/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2022 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { put, select, takeLatest } from 'redux-saga/effects';

import { LOADED_FEATURE_FLAGS } from '../../common/actions';
import { showAccessChanges } from '../data/feature.flags';
import { accessChanges } from '../../ui/toast.list';

let shown;

export function* handleShowAccessChanges() {
  const flag = yield select(showAccessChanges);

  if (!shown && flag && !window.inCypress) {
    shown = true;
    yield put(accessChanges);
  }
}

export default function* watchLoadedFeatureFlags() {
  // shown initialized here so subsequent tests pass
  shown = false;
  yield takeLatest(LOADED_FEATURE_FLAGS, handleShowAccessChanges);
}
